import { useQuery } from 'react-query'
import { config } from 'config'
import { AuthContainer } from 'containers'
import { callAxios, CustomAxiosError } from 'utils/api'
import { getParamsForAll, getQueryParamsForAll } from 'utils/hooks'

const { SECURE_BASE_URL } = config!

type BrandResponse = { brand_name: string }[]

type GetBandRequest = {
  vendorNumber: string
  division: string[]
  category: string[]
  subCategory: string[]
  reportName?: string
}

const getBrand = async (props: GetBandRequest): Promise<BrandResponse> => {
  const { vendorNumber, division, category, subCategory, reportName } = props

  let queryParams = `vendornumber=${vendorNumber}`

  queryParams = getQueryParamsForAll(queryParams, 'commercial_division', division)
  queryParams = getQueryParamsForAll(queryParams, 'commercial_category', category)
  queryParams = getQueryParamsForAll(queryParams, 'commercial_class', subCategory)

  if (reportName) queryParams += `&reportname=${reportName}`

  const { response: brandResponse } = await callAxios<{
    response: { data: BrandResponse }
  }>({
    url: `${SECURE_BASE_URL}/brand?${queryParams}`,
    method: 'GET',
  })

  const filteredBrandResponse = brandResponse.data?.filter((item) => !!item.brand_name)

  return filteredBrandResponse
}

export const useGetBrand = (props: Omit<GetBandRequest, 'vendorNumber'>) => {
  const { division, category, subCategory, reportName } = props
  const { selectedSupplier } = AuthContainer.useContainer()
  const vendorNumber = selectedSupplier?.oracleId ?? ''

  const isEnabled = !!vendorNumber && !!division.length && !!category.length && !!subCategory.length

  const {
    status: getBrandStatus,
    isFetching: getIsBrandLoading,
    data: brandData,
    error: getBrandError,
  } = useQuery<BrandResponse, CustomAxiosError>(
    [
      'brand/get',
      vendorNumber,
      getParamsForAll(division, 'only'),
      getParamsForAll(category, 'only'),
      getParamsForAll(subCategory, 'only'),
      reportName,
    ],
    () => getBrand({ ...props, vendorNumber }),
    {
      enabled: isEnabled,
    }
  )

  return {
    getBrandStatus,
    getIsBrandLoading,
    brandData,
    getBrandError,
  }
}
